import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const REFRIGERANT_EVENTS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('REFRIGERANT_EVENTS');
export const REFRIGERANT_EVENTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	REFRIGERANT_EVENTS_CRUD_ACTION_CONSTANTS
);
